import React,{ useRef, useEffect, forwardRef, useImperativeHandle } from "react";
import { createStore } from "redux";
import { Layer, Group } from 'react-konva';

const randNormal = () => Math.random(0, 10);
const randNormal2 = () => Math.random(0, 10);

const initialState = {
	charges:[],
	generateParticles:false,
	Gravity:0.1,
	lastFrameTime:null,
	mousePos:[null, null],
	particles:[],
	particleIndex:0,
	particlesPerTick:20,
	particleSize:[5, 5],
	svgHeight:600,
	svgWidth:800,
	tickerStarted:false,
	tickerShouldStop:false
};

const vectorVariance = (params) => {
	const signx = Math.random() > 0.5 ? 1 : -1;
	const signy = Math.random() > 0.5 ? 1 : -1;
	const vector = [...params.vector];

	if(params.str_variance != undefined) {
		const str = (Math.random() * 2 * params.str_variance) - params.str_variance;
		vector[0] += str;
		vector[1] += str;
	}

	if(params.dir_variance != undefined) {
		return [
			vector[0] + Math.random() * params.dir_variance[0] * signx,
			vector[1] + Math.random() * params.dir_variance[1] * signy,
		];
	}

	return vector;
};

const particlesApp = (state = initialState, action) => {
	switch(action.type) {
		case 'TICKER_STARTED':
			return { ...state, tickerStarted:true, lastFrameTime:new Date() };
		case 'TICKER_STOPPED':
			return { ...state, tickerStarted:false };
		case 'STOP_TICK':
			return { ...state, tickerShouldStop:true};

		case 'START_PARTICLES':
			return { ...state, generateParticles:true, };

		case 'STOP_PARTICLES':
			return { ...state, generateParticles:false };

		case 'CREATE_PARTICLES_PARAMS':
			let newParticlesParams = state.particles.slice(0);
			let j;
			var numParts = action.params.particles ?? state.particlesPerTick;
			for(j = 0; j < numParts; j++) {
				const x = typeof action.params.source.x == 'function' ? action.params.source.x() : action.params.source.x;
				const y = typeof action.params.source.y == 'function' ? action.params.source.y() : action.params.source.y;
				let particle = {
					id:state.particleIndex + j,
					x,
					y,
				};

				if(action.params.onInvert != undefined) particle.onInvert = action.params.onInvert;

				if(action.params.knv != undefined) {
					particle.knv = action.params.knv(particle.x, particle.y);
					particle.added = false;
				}

				particle.vector = vectorVariance(action.params);
				newParticlesParams.unshift(particle);
			}

			return { ...state, particles: newParticlesParams, particleIndex:(state.particleIndex + j + 1) };


		case 'CREATE_PARTICLES':
			let newParticles = state.particles.slice(0);
			let i;

			for(i = 0; i < action.N; i++) {
				let particle = {
					id:state.particleIndex + i,
					x:action.x,
					y:action.y,
					img:action.img,
				};

				particle.vector = [((particle.id % 2) ? -randNormal() : randNormal()), (-3 * randNormal2())];
				newParticles.unshift(particle);
			}
			return { ...state, particles: newParticles, particleIndex:(state.particleIndex + i + 1) };

		case 'UPDATE_MOUSE_POS':
			return { ...state, mousePos:[action.x, action.y] };

		case 'TIME_TICK':
			let { svgWidth, svgHeight, lastFrameTime } = state;
			let newFrameTime = new Date();
			let multiplier = (newFrameTime - lastFrameTime) / (1000 / 60);

			let movedParticles = state.particles.filter((p) => {
				const valid = !(p.y > svgHeight || p.x < 0 || p.x > svgWidth);

				if(!valid && p.knv != undefined) p.knv.destroy();

				return valid;

			}).map((p) => {
				let [vx, vy] = p.vector;

				p.x += vx * multiplier;
				p.y += vy * multiplier;

				state.charges.forEach((charge) => {
					const dx = p.x - charge.x;
					const dy = p.y - charge.y;
					const r2 = dx * dx + dy * dy;
					const rX = ((dx < 0) ? -(1 / r2) : (1 / r2)) * charge.strength;
					const rY = ((dy < 0) ? -(1 / r2) : (1 / r2)) * charge.strength;
					
					p.x += rX;
					p.y += rY;
				});
				
				p.vector[1] += state.Gravity * multiplier;
				if(vy < 0 && p.vector[1]>0) {
					if (p.onInvert != undefined) {
						setTimeout(()=>{p.onInvert(p.x,p.y)},0);
						p.knv.destroy();
					}
				}

				return p;
			});

			return { ...state, particles:movedParticles, lastFrameTime:new Date() };

		case 'RESIZE_SCREEN':
			return { ...state, svgWidth:action.width, svgHeight:action.height };

		default:
			return state;
	}
};

export const Particles = (props) => {
	const layer = useRef();
	const sprite = useRef();
	const canvas = useRef();
	const context2D = useRef();
	const particles = useRef();

	useEffect(() => {
		const newState = (props.params != undefined) ? { ...initialState, ...props.params } : initialState;
		particles.current = createStore(particlesApp, newState);
		// let img = new Image();
		// img.src = 'http://1.bp.blogspot.com/-sgRdkb1Eu0M/UioQc6yWCXI/AAAAAAAACkE/3lkhQhiFAcA/s1600/minion_icon_image_picfishblogspotcom+%252814%2529.png';
		// sprite.current = img;
	}, [props.params]);

	useEffect(() => {
		if(!props.stage) return;
		const { width, height } = props.stage.attrs;
		particles.current.dispatch({ type:'RESIZE_SCREEN', width, height });
		props.stage.on('mousedown touchstart', handleMouseDown);
		props.stage.on('mouseup touchend', handleMouseUp);
		props.stage.on('mousemove touchmove', handleMouseMove);
	}, [props.stage]);

	useEffect(() => {
		if(!layer.current || !props.canvas_context) return;

		canvas.current = layer.current.canvas._canvas;
		context2D.current = canvas.current.getContext('2d');
		particles.current.dispatch({ type:'TICKER_STARTED' });
		const retina = (props.canvas_context) ? props.canvas_context.getCanvas().pixelRatio : 1;
		
		let ticker_subs;
		let ticker = () => {
			const state = particles.current.getState();
			let test = false;
			if(props.canvas_context) {
				const im_x = state.mousePos[0] * retina - 50;
				const im_y = state.mousePos[1] * retina - 50;
				const im_w = state.particleSize[0];
				const im_h = state.particleSize[1];
				test = props.canvas_context.getImageData(im_x, im_y, im_w, im_h);
			}

			if(state.generateParticles) {
				particles.current.dispatch({ type:'CREATE_PARTICLES', N:state.particlesPerTick, x:state.mousePos[0], y:state.mousePos[1], img:test });
			}

			particles.current.dispatch({ type:'TIME_TICK' });
			const part = particles.current.getState().particles;

			if(part) {
				context2D.current.clearRect(0, 0, canvas.current.width, canvas.current.height);

				for(let i = 0; i < part.length; i++) {
					const { x, y, img } = part[i];
					if(test) context2D.current.putImageData(img, x * retina, y * retina);
					//context2D.current.drawImage(sprite.current,0,0,128,128,x,y,15,15);
				}
			}

			ticker_subs = window.requestAnimationFrame(ticker);
		}

		ticker();

		return () => {
			cancelAnimationFrame(ticker_subs);
		};
	}, [layer.current, props.canvas_context]);

	const handleMouseDown = (e) => {
		particles.current.dispatch({ type:'START_PARTICLES' });
		const stage = e.target.getStage();
		let lastPoint = stage.getPointerPosition();
		particles.current.dispatch({ type:'UPDATE_MOUSE_POS', ...lastPoint });
	};

	const handleMouseUp = () => {
		particles.current.dispatch({ type:'STOP_PARTICLES' });
	};

	const handleMouseMove = (e) => {
		const stage = e.target.getStage();
		let lastPoint = stage.getPointerPosition();
		particles.current.dispatch({ type:'UPDATE_MOUSE_POS', ...lastPoint });
	};

	return (
		<Layer ref={layer} listening={false} />
	)
}


export const ExternalParticles = forwardRef((props, ref) => {
	const layer = useRef();
	const sprite = useRef();
	const canvas = useRef();
	const context2D = useRef();
	const particles = useRef();

	useEffect(() => {
		const newState = (props.params != undefined) ? { ...initialState, ...props.params } : initialState;
		particles.current = createStore(particlesApp, newState);
	}, [props.params]);

	useEffect(() => {
		if(!props.stage) return;
		const { width, height } = props.stage.attrs;
		particles.current.dispatch({ type:'RESIZE_SCREEN', width, height });
	}, [props.stage]);

	useEffect(() => {
		if(!layer.current || !props.canvas_context) return;

		canvas.current = layer.current.canvas._canvas;
		context2D.current = canvas.current.getContext('2d');
		particles.current.dispatch({ type:'TICKER_STARTED' });
		const retina = (props.canvas_context) ? props.canvas_context.getCanvas().pixelRatio : 1;
		
		let ticker_subs;
		let ticker = () => {
			const state = particles.current.getState();
			let test = false;

			if (sprite.current != null) {
				test = sprite.current;
			}

			if(state.generateParticles) {
				particles.current.dispatch({ type:'CREATE_PARTICLES', N:state.particlesPerTick, x:state.mousePos[0], y:state.mousePos[1], img:test });
			}

			particles.current.dispatch({ type:'TIME_TICK' });
			const part = particles.current.getState().particles;

			if(part) {
				context2D.current.clearRect(0, 0, canvas.current.width, canvas.current.height);

				for(let i = 0; i < part.length; i++) {
					const { x, y, img } = part[i];
					if(test) context2D.current.putImageData(img, x * retina, y * retina);
					//context2D.current.drawImage(sprite.current,0,0,128,128,x,y,15,15);
				}
			}

			ticker_subs = window.requestAnimationFrame(ticker);
		}

		ticker();

		return () => {
			cancelAnimationFrame(ticker_subs);
		};
	}, [layer.current, props.canvas_context]);

	const handleMouseDown = (e,source) => {
		particles.current.dispatch({ type:'START_PARTICLES' });
		sprite.current = source;
		const stage = e.target.getStage();
		let lastPoint = stage.getPointerPosition();
		particles.current.dispatch({ type:'UPDATE_MOUSE_POS', ...lastPoint });
	};

	const handleMouseUp = () => {
		particles.current.dispatch({ type:'STOP_PARTICLES' });
	};

	const handleMouseMove = (e,source) => {
		const stage = e.target.getStage();
		let lastPoint = stage.getPointerPosition();
		if (source) sprite.current = source;
		particles.current.dispatch({ type:'UPDATE_MOUSE_POS', ...lastPoint });
	};

	useImperativeHandle(ref, () => ({
		down(e,source) {
			handleMouseDown(e,source);
		},
		up(e) {
			handleMouseUp()
		},
		move(e,source){
			handleMouseMove(e,source)
		},
		/*shoot(params) {
			particles.current.dispatch({ type:'CREATE_PARTICLES_PARAMS', params });
		},*/
	}), []);

	return (
		<Layer ref={layer} listening={false} />
	)
});

export const Confetti = forwardRef((props, ref) => {
	const layer = useRef();
	const particles = useRef();
	const ticker_sub = useRef();
	const no_particles_count = useRef(0);
	const no_part_limit = 50;

	useEffect(() => {
		const newState = (props.params != undefined) ? { ...initialState, ...props.params } : initialState;
		particles.current = createStore(particlesApp, newState);
	}, [ props.params ]);

	useEffect(() => {
		if(!props.canvas_size) return;

		const { width, height } = props.canvas_size;
		particles.current.dispatch({ type:'RESIZE_SCREEN', width, height });
	}, [ props.canvas_size ]);

	const ticker = () => {
		particles.current.dispatch({ type:'TIME_TICK' });
		const state = particles.current.getState();
		const part = state.particles;
		if(part && part.length > 0) {
			for(let i = 0; i < part.length; i++) {
				const { x, y } = part[i];
				
				if(!part[i].added) {
					layer.current.add(part[i].knv);
					part[i].added = true;
				} else {
					part[i].knv.x(x);
					part[i].knv.y(y);
				}
			}
			layer.current.getLayer().draw();
		}
		if(part.length > 0 || !state.tickerShouldStop) {
			if(state.tickerStarted) ticker_sub.current = window.requestAnimationFrame(ticker);
		} else if (part.length == 0) {
			no_particles_count.current++;
			if(no_particles_count.current > no_part_limit) {
				no_particles_count.current = 0;
				particles.current.dispatch({ type:'TICKER_STOPPED' });
			}
		}
	}

	useEffect(() => {
		if(!layer.current) return;

		return () => {
			cancelAnimationFrame(ticker_sub.current);
		};
	}, [layer.current]);

	useImperativeHandle(ref, () => ({
		shoot(params) {
			if (!particles.current.getState().tickerStarted) {
				particles.current.dispatch({ type:'TICKER_STARTED' });
				ticker();
			}
			particles.current.dispatch({ type:'CREATE_PARTICLES_PARAMS', params });
		},
		stop() {
			particles.current.dispatch({ type:'STOP_TICK'});
		}
	}), []);

	return (
		<Group ref={layer} listening={false} />
	)
});